import _ from 'lodash';
import { useState } from 'react';
import { EmailStatusTable } from '@/features/emails/components/email-status-table';
import { useGetMeetingDatesQuery } from '@/features/meetings/gql/_gen_/meeting.gql';
import { SectionContainer } from '@/features/reports/components/section-container';
import { today } from '@/helpers/date-helpers';
import { DatePager } from './date-pager';

interface EmailTableSectionProps {
  brandCode?: string | null;
  timezone?: string | null;
}

export function EmailTableSection({ brandCode, timezone }: EmailTableSectionProps) {
  const todaysDate = today();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [dates, setDates] = useState<string[]>([]);

  const { loading, error } = useGetMeetingDatesQuery({
    skip: !brandCode,
    variables: {
      brandCode,
      limit: 300,
    },
    onCompleted: (data) => {
      if (data?.getMeetingDates) {
        const meetingDates = data.getMeetingDates.map((meetings) => meetings?.meetingDate ?? '');

        // Add today's date if it's not in the list
        if (!meetingDates.includes(todaysDate)) {
          meetingDates.push(todaysDate);
        }

        const sortedDates = meetingDates.sort();
        const index = _.findIndex(sortedDates, (date) => date === todaysDate);
        setSelectedIndex(index);
        setDates(sortedDates);
      }
    },
  });

  const handlePrevious = () => {
    // if the selected index is 0, do nothing
    if (selectedIndex === 0) return;
    setSelectedIndex(selectedIndex - 1);
  };
  const handleNext = () => {
    // if the selected index is the last index, do nothing
    if (selectedIndex === dates.length - 1) return;
    setSelectedIndex(selectedIndex + 1);
  };

  if (!brandCode) return null;

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;

  return (
    <SectionContainer
      title='Emails Sent'
      toolbar={
        <DatePager
          dates={dates}
          currentIndex={selectedIndex}
          onPrevious={handlePrevious}
          onNext={handleNext}
        />
      }
    >
      <EmailStatusTable
        brandCode={brandCode}
        meetingDate={dates[selectedIndex]}
        timezone={timezone}
      />
    </SectionContainer>
  );
}
